import React, { useState, useEffect } from "react";
import { GoogleApiWrapper } from "google-maps-react";
import NearMeIcon from "@mui/icons-material/NearMe";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import usePlacesAutocomplete, { getGeocode, getLatLng } from "use-places-autocomplete";

import {
    Combobox,
    ComboboxInput,
    ComboboxPopover,
    ComboboxList,
    ComboboxOption,
    ComboboxOptionText,
} from "@reach/combobox";
import "@reach/combobox/styles.css";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import Divider from "@mui/material/Divider";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import useOnclickOutside from "react-cool-onclickoutside";
import SearchIcon from "@mui/icons-material/Search";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import "./style.css";
import { getAddress } from "../../services/google";
import zIndex from "@mui/material/styles/zIndex";

const GoogleAutoComplete = (props) => {
    return (
        <span className="GoogleAutoComplete">
            <PlacesAutocomplete props={props} setZoom={props.setZoom} />
        </span>
    );
};

const PlacesAutocomplete = ({ props, setZoom }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [recentSearches, setRecentSearches] = useState([]);

    let lastLocation = localStorage.getItem("lastLocation");
    if (lastLocation) {
        lastLocation = JSON.parse(lastLocation);
    }

    const {
        ready,
        value,
        setValue,
        suggestions: { status, data },
        clearSuggestions,
    } = usePlacesAutocomplete({ cache: 24 * 60 * 60 });

    useEffect(() => {
        const storedSearches = JSON.parse(localStorage.getItem("recentSearches"));
        if (storedSearches) {
            setRecentSearches(storedSearches);
            if (!value) {
                //setValue(storedSearches[0]);
            }
        }
    }, []);

    /**
     * This method will show the menue
     * @param {*} value
     */
    const showMenu = (value) => {
        if (!value || data?.length === 0) {
            setIsMenuOpen(true);
        }
    };
    /**
     * This method will hanlde the combobox input change
     * @param {*} value
     */
    const handleSearchLocation = (value) => {
        setIsMenuOpen(false);
        if (!value) setIsMenuOpen(true);

        setValue(value);
    };

    /**
     * This method will handle the click event on search icon
     */
    const handleSearchClick = () => {
        let lastLocation = localStorage.getItem("lastLocation");
        if (lastLocation) {
            lastLocation = JSON.parse(lastLocation);
            props.onSelect(lastLocation);
            setZoom(12);
        }
    };

    /**
     * This method will hanlde the selcet from the combobox
     * @param {*} address
     */
    const handleSelect = async (address) => {
        setIsMenuOpen(false);
        setValue(address, false);
        localStorage.removeItem("map-zoom-level");

        clearSuggestions();

        const result = await getGeocode({ address });
        const updatedValues = [...recentSearches, address].slice(-3);
        const reversedValues = updatedValues.slice().reverse();
        const uniqueValues = reversedValues.filter((value, index, self) => self.indexOf(value) === index);

        setRecentSearches(uniqueValues);
        localStorage.setItem("lastLocation", JSON.stringify(result[0]));
        localStorage.setItem("recentSearches", JSON.stringify(uniqueValues));

        props.onSelect(result[0]);

        setZoom(12);
    };

    const ref = useOnclickOutside(() => {
        // When user clicks outside of the component, we can dismiss
        // the searched suggestions by calling this method
        setTimeout(() => {
            clearSuggestions();
            setIsMenuOpen(false);
        }, 1000);
    });

    /**
     * This method handle the current location click
     */
    const handleCurrentLocation = () => {
        if (navigator.geolocation) {
            // Passing in a success callback and an error callback fn
            navigator.geolocation.getCurrentPosition(showPosition, handleCurrentLocationError);
        } else {
            // Alert is browser does not support geolocation
            alert("Sorry, Geolocation is not supported by this browser.");
        }
    };

    /**
     * This method will shoe position
     * @param {*} position
     */
    const showPosition = async (position) => {
        let lat = position.coords.latitude;
        let long = position.coords.longitude; // You have obtained longitude coordinate!

        let address = await getAddress(lat, long);
        if (address?.results?.length > 4) {
            let formatted_address = address?.results[5]?.formatted_address;
            handleSelect(formatted_address);
        }
    };

    /**
     * This method will handle the current location error
     */
    const handleCurrentLocationError = () => {
        if (navigator.permissions) {
            navigator.permissions.query({ name: "geolocation" }).then((res) => {
                if (res.state === "denied") {
                    alert("Enable location permissions for this website in your browser settings.");
                }
            });
        } else {
            alert("Unable to access your location. You can continue by submitting location manually."); // Obtaining Lat/long from address necessary
        }
    };

    /**
     * This method will handle the Recent location
     * @param {*} index
     */
    const handleRecentLocation = (index) => {
        handleSelect(recentSearches[index]);
    };

    /**
     * This method will display the menu list
     * @returns
     */
    const displayMenuList = () => {
        return (
            <div className="list">
                <List sx={{ width: "100%", maxWidth: 450 }} component="nav" aria-labelledby="nested-list-subheader">
                    <ListItemButton onClick={handleCurrentLocation}>
                        <ListItemIcon>
                            <NearMeIcon sx={{ color: "#2E8BC0" }} />
                        </ListItemIcon>
                        <ListItemText primary="Current Location" />
                    </ListItemButton>
                    {recentSearches?.length > 0 && (
                        <>
                            <ListSubheader>{"RECENT SEARCH"}</ListSubheader>
                            <Divider light />
                            {recentSearches.map((value, index) => (
                                <>
                                    <ListItemButton key={index} onClick={() => handleRecentLocation(index)}>
                                        <ListItemIcon>
                                            <AccessTimeFilledIcon sx={{ color: "#2E8BC0" }} />
                                        </ListItemIcon>
                                        <ListItemText primary={value} />
                                    </ListItemButton>
                                    <Divider light />
                                </>
                            ))}
                        </>
                    )}
                </List>
            </div>
        );
    };

    return (
        <div ref={ref}>
            <Combobox onSelect={handleSelect}>
                <Box sx={{ position: "relative" }}>
                    <Grid sx={{ display: "flex" }}>
                        <Grid item>
                            <ComboboxInput
                                value={value}
                                onChange={(e) => handleSearchLocation(e.target.value)}
                                disabled={!ready}
                                className="combobox-input combobox"
                                placeholder="City, Address, ZIP"
                                onClick={(e) => showMenu(e.target.value)}
                            />
                            <Box className="search-icon" sx={{ mt: "1px" }} onClick={handleSearchClick}>
                                <SearchIcon></SearchIcon>
                            </Box>
                        </Grid>
                    </Grid>

                    {isMenuOpen && displayMenuList()}
                    {status === "OK" && data?.length > 0 && (
                        <ComboboxPopover
                            style={{
                                zIndex: "10001",
                                borderRadius: "20px",
                                width: "350px",
                                marginTop: "2px",
                            }}
                        >
                            <ComboboxList className="combobox-list-container" style={{ borderRadius: "20px" }}>
                                {data.map(({ place_id, description }) => (
                                    <>
                                        <ComboboxOption
                                            className="google-auto-complete-combobox-list"
                                            style={{
                                                padding: "8px 12px",
                                                borderBottom: "1px solid #D0D5DD",
                                            }}
                                            key={place_id}
                                            value={description}
                                        />
                                    </>
                                ))}
                            </ComboboxList>
                        </ComboboxPopover>
                    )}
                </Box>
            </Combobox>
        </div>
    );
};

const LoadingContainer = (props) => <div></div>;

export default GoogleApiWrapper({
    apiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    version: "beta",
    libraries: ["common", "util", "map", "overlay", "onion", "controls", "stats", "places", "geometry"],
    LoadingContainer: LoadingContainer,
})(GoogleAutoComplete);
